import { render, staticRenderFns } from "./OstolaskuUusi.vue?vue&type=template&id=27296cd5&scoped=true&"
import script from "./OstolaskuUusi.vue?vue&type=script&lang=js&"
export * from "./OstolaskuUusi.vue?vue&type=script&lang=js&"
import style0 from "./OstolaskuUusi.vue?vue&type=style&index=0&id=27296cd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27296cd5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VFileInput,VIcon,VRow,VToolbar,VToolbarTitle,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27296cd5')) {
      api.createRecord('27296cd5', component.options)
    } else {
      api.reload('27296cd5', component.options)
    }
    module.hot.accept("./OstolaskuUusi.vue?vue&type=template&id=27296cd5&scoped=true&", function () {
      api.rerender('27296cd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OstolaskuUusi.vue"
export default component.exports